<template>
  <div class="news container pb-5 pt-8 pt-lg-8">
    <PageLoader v-if="loading" />
    <h2 class="text-primary text-center fw-bold">{{$t('articles')}}</h2>
    <div class="d-flex justify-content-center py-3 flex-wrap gap-4">
      <div v-for="news in allNews" :key="news.id">
        <NewsCard :news="news"></NewsCard>
      </div>
    </div>
  </div>
</template>
<script>
import PageLoader from '@/components/PageLoader.vue'
import NewsCard from '@/components/NewsCard.vue'
import { mapState } from 'vuex'
export default {
  components: {
    PageLoader,
    NewsCard
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState({
      allNews: state => state.news.news
    })
  }
}
</script>
<style></style>
